import React from 'react';
import AdobePluginInstallInstructions from './adobe-plugin';
import type { IntegrationInstallInstructionsProps } from '@pages/AdminSettings/components/IntegrationTab/constants';

export default function PremiereProInstallInstructions({
  organizationId,
  installed,
  onClose
}: IntegrationInstallInstructionsProps) {
  return (
    <AdobePluginInstallInstructions
      pluginType="premiere_pro"
      organizationId={organizationId}
      installed={installed}
      onClose={onClose}
    />
  );
}
